import { render, staticRenderFns } from "./OmniWidget.vue?vue&type=template&id=71cecebe"
import script from "./OmniWidget.vue?vue&type=script&lang=js"
export * from "./OmniWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports